/**
 * Created by Arif Topcu in 2019
 */

import React, { memo, useCallback } from "react";
import ComplicationSelector from "@ls/grouping-complication-selector";
import PerfReturnDefinition from "state/perfReturns/PerfReturnDefinition";
import Complication from "./PerfReturnSelectorComplication";
import { useDispatch, useSelector } from "react-redux";
import { selectDefinitions } from "state/perfReturns/selectors";
import SelectionState from "state/selections/SelectionState";
import { setDefinition as setPerfReturnDefinition } from "state/perfReturns/actions";

const PerfReturnsSelector = () => {
  const dispatch = useDispatch();
  const definitions = useSelector(
    selectDefinitions(SelectionState.UNCOMMITTED)
  );
  const setDefinition = useCallback(
    (definitions, idx) => dispatch(setPerfReturnDefinition(definitions, idx)),
    [dispatch]
  );

  return (
    <ComplicationSelector
      selectedDefinitions={definitions}
      setDefinition={setDefinition}
      getDefaultDefinition={PerfReturnDefinition.getDefault}
      ComplicationComponent={Complication}
      btnTitle={"Performance Returns"}
      addMoreText={"Performance Return Column"}
    />
  );
};

export default memo(PerfReturnsSelector);
